import {Typography, useTheme} from '@mui/material';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import Icon from 'presentation/icons';
import IconNamesType from 'presentation/icons/IconNamesType';

import {Loading} from 'presentation/components/Loading/Loading';

import {
	StyledCard,
	StyledCardActionArea,
	StyledIconButtonContainer,
	StyledIconIllustration,
	StyledStack,
} from './styles';
import {ServiceCardProps} from './types';

export function ServiceCard({
	route,
	icon,
	title,
	hasMaxWidth,
	isCardInfo = false,
	onClick,
	size = 'medium',
	isLoading,
	isExternalLink,
	dataTagId,
}: ServiceCardProps) {
	const navigate = useNavigate();
	const theme = useTheme();

	const handleClick = (): void => {
		if (route) {
			navigate(route);
			return;
		}

		onClick?.();
	};

	const getCardInfoProps = () => {
		let props = {
			size: 20,
			name: 'arrow-right-filled' as IconNamesType,
			color: theme.palette.primary.main,
		};
		if (isCardInfo) {
			props = {
				...props,
				name: 'info-outlined' as IconNamesType,
				color: theme.colors.gray['54Percent']!,
			};
		}

		if (isExternalLink) {
			props = {
				...props,
				name: 'external-link-default' as IconNamesType,
				color: theme.palette.primary.main,
			};
		}

		return props;
	};

	return (
		<StyledCardActionArea
			onClick={handleClick}
			$hasMaxWidth={hasMaxWidth}
			data-tag-id={dataTagId}>
			<StyledCard variant="outlined" size={size}>
				<StyledStack>
					{icon ? (
						<StyledIconIllustration
							customIconName={icon}
							variant="primary"
							size="smaller"
						/>
					) : null}

					<Typography variant="body2">{title}</Typography>
				</StyledStack>
				<StyledIconButtonContainer>
					{isLoading ? <Loading size={20} /> : <Icon {...getCardInfoProps()} />}
				</StyledIconButtonContainer>
			</StyledCard>
		</StyledCardActionArea>
	);
}
